import { createSelector } from "reselect";

import { colorSelectors } from "../../modules/definition/colors";
import { propertySelectors } from "../../modules/definition/properties";
import { syncSelectors } from "../../modules/sync";
import syncRepresentationOfCustomFields from "./syncRepresentationOfCustomFields";

const syncRepresentationOfCustomFieldsFromStatusState = createSelector(
  // inputs
  colorSelectors.getColors,
  propertySelectors.getPropertiesById,
  syncSelectors.getCustomFieldsIdsMap,
  syncSelectors.getUpdatedSettingsOrSettings,

  // calculate based on inputs
  syncRepresentationOfCustomFields
);

export default syncRepresentationOfCustomFieldsFromStatusState;
